import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TEXT,
  attribute: 'payments_slack_channel',
  label: {
    default: 'Payments slack channel',
    short: 'Payments',
  },
});
